import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenShippingModal: boolean
  toggleShippingModal: (isOpen: boolean) => void
}

export const ShippingListViewContext = createContext<IContext>({
  isOpenShippingModal: false,
  toggleShippingModal: () => {},
})

export const ShippingListViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenShippingModal, setIsOpenShippingModal] = useState(false)

  const toggleShippingModal = (isOpen: boolean) => {
    setIsOpenShippingModal(isOpen)
  }

  return (
    <ShippingListViewContext.Provider
      value={{
        isOpenShippingModal,
        toggleShippingModal,
      }}>
      {children}
    </ShippingListViewContext.Provider>
  )
}
